import { Injectable, signal } from '@angular/core';
import { NavigationItem } from '../models/navigation.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  activeSection = signal<string>('dashboard');
  sidebarOpen = signal<boolean>(false);

  navigation: NavigationItem[] = [
    { id: 'dashboard', name: 'Dashboard', icon: 'layout-dashboard' },
    { id: 'royalties', name: 'Royalties & Payments', icon: 'dollar-sign' },
    // { id: 'analytics', name: 'Analytics', icon: 'trending-up' },
    // { id: 'notifications', name: 'Notifications', icon: 'bell' },
    // { id: 'support', name: 'Support', icon: 'message-square' },
    // { id: 'settings', name: 'Settings', icon: 'settings' }
  ];

  setActiveSection(section: string): void {
    this.activeSection.set(section);
    this.sidebarOpen.set(false);
  }

  toggleSidebar(): void {
    this.sidebarOpen.update(value => !value);
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }
}
